import retention from "@/api/retention";
import adhocInvoice from "@/store/Retentions/AdhocInvoice";
import proformaInvoice from "@/store/Retentions/ProformaInvoice";

const state = () => ({
  retentionLeadsLoading: false,
  singleRetentionLead: {},
  retentionLeadRecord: false,

  retentionLeads: {
    leads: [],
    config: {
      pagination: {
        page: null,
        limit: null,
        sort: null,
        order: null,
      },
      queryParams: {
        agent_sid: null,
        status__in: null,
        creation_timestamp__gte: null,
        creation_timestamp__lte: null,
        closed_timestamp__gte: null,
        closed_timestamp__lte: null,
        transfers: null,
        contains_voip: null,
        contains_telco: null,
        contains_websites: null,
        no_contact: null,
      },
      paginationCount: 0,
    },
  },

  retentionAgents: [],
  retentionReports: [],
  createRetentionErrors: false,
  auditHistoryLoading: false,
  auditHistory: {
    logs: [],
    config: {
      paginationCount: 0,
      paginationLimit: 10,
      paginationPage: 1,
    }
  },
  dropdowns: {
    sources: ['Incoming call','Email','Transfer request(attempts to be included)'],
    providers: ['8x8','BT','Cease','Chess','Daisy','Onebill','Plusnet','Talk Talk','XLN','Toople','Titan','Unicom','Kinex','Onebill','Virgin','SKY','Vodafone','Other','Rincentral','Vonage','CircleLoop','Soho66','Focus Group','VoIP Studio','Lili Comms','Gamma'].sort(),
    departments: ['Digital','DART','Cancellations', 'Credit control','Front line','Faults','Onboarding','Sales','Provisioning','Gamma Transfer Out Request','BT/TT Transfer Out Request','VoIP Care','Incoming call IVR','Sales','ACM'].sort(),
    savedReasons: ['Slow speeds, upgraded to Fibre','Refuse to TS, client agreed','Slow speeds, moved to BTW','Billing issues, resolved','Poor service, retained','Out of contract rates, renewed','Ombudsman case, retained','Porting Issues, resolved','Password reset issue, resolved','Mis-sold, resolved','Constant techical issues, agreed to TS','1 star review / Escalation, resolved','Order delay, resolved','No follow up or call backs, resolved','Call Quality, Agreed to TS','Onboarding not done, session booked','Other','LP Price matched/Renewed','No fibre avail, agreed to adsl','PAF issues, agreed to update RM','Number cannot be ported, agreed to new number','Provider rejecting transfer, agreed to new line','Not updating customer, resolved','Porting delays, agreed to new number'].sort(),
    retentions: ['WIP','Lost','Saved'].sort(),
    categories: [
      { text: "Business closed", value: "businessClosed" },
      { text: "Service", value: "service" },
      { text: "Telco Product", value: "telcoProduct" },
      { text: "VoIP Product", value: "voipProduct" },
      { text: "Pricing", value: "pricing" },
      { text: "Sales", value: "sales" },
      { text: "Transfer Out", value: "transferOut" },
      { text: "Billing", value: "billing" },
      { text: "Other", value: "other"},
    ],
    reasons: {
      businessClosed: [
        { text: "Business closed" },
      ],
      service: [
        { text: "Agent breakage" },
        { text: "Provisioning delay" },
        { text: "Porting delay" },
        { text: "Delivery delay" },
        { text: "Failure to escalate" }
      ],
      telcoProduct: [
        { text: "Unresolved faults" },
        { text: "Slow speed" },
        { text: "No upgrade available" },
        { text: "WFH - S/O" },
        { text: "Using mobile" },
        { text: "Need special features" },
        { text: "Outages" },
        { text: "Network reliability" },
      ],
      voipProduct: [
        { text: "Handset fault" },
        { text: "Mobile app fault" },
        { text: "Desktop app fault" },
        { text: "Lack of feature" },
        { text: "Network reliability" },
        { text: "Don't like UX" },
        { text: "WFH - S/O" },
        { text: "Hardware not compatible" },
        { text: "Outages" },
        { text: "Need special features" },
      ],
      pricing: [
        { text: "OCC price increase" },
        { text: "Offered lower price" },
        { text: "Addon-on charges" },
        { text: "Can't afford it" },
        { text: "Price match" },
        { text: "Tariff increase" },
      ],
      sales: [
        { text: "Trial/M2M" },
        { text: "Mis-sold" },
        { text: "BT/TTB availability" },
      ],
      transferOut: [
        { text: "Slammed" },
        { text: "TO - no contact" },
      ],
      billing: [
        { text: "Engineer fee" },
        { text: "Billing errors" },
        { text: "Credits dispute" }
      ],
      other: [
        { text: "Management clean up" },
        { text: "Complaint customer bundle" },
        { text: "DOA" },
        { text: "Deceased" },
        { text: "Dealer dispute" },
        { text: "No traffic on the line" },
      ]
    },
    subReasons: {
      billing: ['Incorrect Billing'],
      ceaseBcd: ['Business closed down - Covid','Business closed down','Terminal illness','Lease issues'],
      serviceAgentMishandled: ['Agent error'],
      servicePortingDelay: ['Porting delays','New line installed'],
      onboardingIssue: ['Onboarding issue'],
      serviceOrderDelay: ['Order delays','Transfer rejected','LP quarantined number','PAF issues','Missed Appointment'],
      serviceSupport: ['Customer requires 24/7 support'],
      ceaseMoveToSO: ['Cease - Move to S/O'],
      pricePriceMatchRefused: ['LP Price matched/cheaper tariff','LP Price matched/Renewed','COT/COP','No TT/BT Availability'],
      salesMissold: ['Mis-sold','Sold on cooling','Incorrect sale capture','Mis-sold on speeds','Number cannot be ported','Feature not available','Unable to contact customer'],
      technicalVoIPFault: ['App fault','Hardware fault','Refused router cost','Call fault','Feature fault'],
      technicalTelcoFault: ['Hardware fault','Call fault','Feature fault','Slow speeds fault','Telco Infrastucture issues','Telco Timeframes','Unable to provide upgrade'],
      ombudsmanCase:['Ombudsman case'],
      trial:['Trial ended','30 Day Love-It Guarantee'],
      notNeeded:['No use / Not fit for businesss model'],
      legalZoom:['Legal Zoom'],
      to:['Line slammed','Transfer out rejected','Transfer rejected / No contact'],
      copCot:['COP','COT'],
      notInUse:['Not fit for business model','Alternative product','Out of contract','Business Downsized'],
    },
  },

  retentionLeadNotes: [],
  fetchRetentionLeadNotesLoading: false,
  fetchRetentionLeadNotesError: false,
  fetchRetentionLeadNotesErrorResponse: null,

  createRetentionLeadNoteLoading: false,
  createRetentionLeadNoteError: false,
  createRetentionLeadNoteErrorResponse: null
});

const mutations = {
  SET_RETENTION_LEAD_RECORD(state,payload){
    state.retentionLeadRecord = payload;
  }, 
  SET_RETENTION_LEAD(state,payload){
    state.singleRetentionLead = payload;
  }, 
  SET_AUDIT_HISTORY_LOADING(state,payload){
    state.auditHistoryLoading = payload;
  },
  SET_AUDIT_HISTORY(state,payload){
    state.auditHistory.config.paginationCount = parseInt(payload.headers['pagination-count']);
    state.auditHistory.logs = payload.data;
    state.auditHistoryLoading = false;
  },
  UPDATE_AUDIT_PAGINATION(state,options){
    state.auditHistory.config.paginationLimit = options.itemsPerPage;
    state.auditHistory.config.paginationPage = options.page;
  },
  GET_RETENTION_LEADS(state, { data, headers }) {
    state.retentionLeads.leads = data;
    state.retentionLeads.config.paginationCount = parseInt(headers['pagination-count']);
    state.retentionLeads.config.pagination.limit = parseInt(headers['pagination-limit']);
    state.retentionLeads.config.pagination.page = parseInt(headers['pagination-page']);
  },
  UPDATE_RETENTION_PAGINATION(state, { pagination, queryParams }) {
    if(pagination) {
      for(let param in state.retentionLeads.config.pagination) {
        if(pagination[param]) {
          state.retentionLeads.config.pagination[param] = pagination[param];
        }
      }
    }
    
    if(queryParams) {
      for(let param in state.retentionLeads.config.queryParams) {
        if(queryParams.hasOwnProperty(param)) {
          if(param.includes("__in") && typeof queryParams[param] === "string") {
            state.retentionLeads.config.queryParams[param] = queryParams[param].split(",");
          } else {
            state.retentionLeads.config.queryParams[param] = queryParams[param];
          }
        }
      }
    }
  },
  setErrors(state, boolean) {
    state.createRetentionErrors = boolean;
  },
  setLoading(state, loading) {
    state.retentionLeadsLoading = loading;
  },
  setAgents(state, payload) {
    state.retentionAgents = payload;
  },
  setRetentionReports(state, payload) {
    state.retentionReports = payload;
  },

  FETCH_RETENTION_LEAD_NOTES_BEGIN(state) {
    state.fetchRetentionLeadNotesLoading = true;
    state.fetchRetentionLeadNotesError = false;
    state.fetchRetentionLeadNotesErrorResponse = null;
  },
  FETCH_RETENTION_LEAD_NOTES_SUCCESS(state, payload) {
    state.retentionLeadNotes = payload;
    state.fetchRetentionLeadNotesLoading = false;
  },
  FETCH_RETENTION_LEAD_NOTES_ERROR(state, err) {
    state.fetchRetentionLeadNotesLoading = false;
    state.fetchRetentionLeadNotesError = true;
    state.fetchRetentionLeadNotesErrorResponse = err;
  },

  CREATE_RETENTION_LEAD_NOTE_BEGIN(state) {
    state.createRetentionLeadNoteLoading = true;
    state.createRetentionLeadNoteError = false;
    state.createRetentionLeadNoteErrorResponse = null;
  },
  CREATE_RETENTION_LEAD_NOTE_SUCCESS(state) {
    state.createRetentionLeadNoteLoading = false;
  },
  CREATE_RETENTION_LEAD_NOTE_ERROR(state, err) {
    state.createRetentionLeadNoteLoading = false;
    state.createRetentionLeadNoteError = true;
    state.createRetentionLeadNoteErrorResponse = err;
  }
};

const actions = {
  async updateRetentionLead({commit,dispatch},{data}){
    try{
      let res = await retention.updateRetentionLead(data);
      if(res.status===200){
        commit('SET_RETENTION_LEAD',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      throw error;
    }
  },
  async createRetentionLeadRecord({commit,dispatch},data){
    try{
      let res = await retention.createRetentionLeadRecord(data);
      if(res.status===200){
        commit('SET_RETENTION_LEAD_RECORD',true);
      }else{
        commit('SET_RETENTION_LEAD_RECORD',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      commit('SET_RETENTION_LEAD_RECORD',false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async updateRetentionLeadRecord({commit,dispatch},data){
    try{
      let res = await retention.updateRetentionLeadRecord(data);
      if(res.status===200){
        commit('SET_RETENTION_LEAD_RECORD',true);
      }else{
        commit('SET_RETENTION_LEAD_RECORD',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      commit('SET_RETENTION_LEAD_RECORD',false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async getRetentionLead({ commit },id){
    try{
      let data = await retention.getRetentionLead(id);
      if(data.status===200){
        commit('SET_RETENTION_LEAD',data.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: data.response.data.message}, { root: true });
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async updateAuditPagination({commit,dispatch},{id,options}){
    await commit('UPDATE_AUDIT_PAGINATION',options);
    dispatch('getAuditHistory',id);
  },
  async getAuditHistory({state,commit,dispatch},id){
    commit('SET_AUDIT_HISTORY_LOADING',true);
    try{
      let data = await retention.getAuditHistory(id,state.auditHistory.config);
      if(data.status===200){
        commit('SET_AUDIT_HISTORY',data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: data.response.data.message}, { root: true });
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async createRetentionLead({ commit,dispatch },{payload}) {
    commit("setErrors", false);
    try{
      let data = await retention.createRetentionLead(payload);
      commit("GET_RETENTION_LEADS", {data:data.data,headers:data.headers});
      commit("setLoading", false);
      dispatch("alerts/setAlert", {type: "success",message: "Create retention lead successful!"}, { root: true });
      return data.data.id;
    }catch(error){
      commit("setErrors", true);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  loadRetentionLeads({ state, commit }) {
    commit("setLoading", true);
    
    const url = new URL(window.location);
    const query = {};

    Object.entries({ ...state.retentionLeads.config.pagination, ...state.retentionLeads.config.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
        url.searchParams.set(k,v);
      } else {
        url.searchParams.delete(k);
      }
    });

    window.history.pushState(null, '', url.toString());
    
    return retention
      .getRetentionLeads(query)
      .then(({ data, headers }) => {
        commit("GET_RETENTION_LEADS", { data, headers });
        commit("setLoading", false);
      })
      .catch(() => {
        commit("setLoading", false);
        commit("GET_RETENTION_LEADS", [])
      });
  },
  downloadExportByFilter({ state }) {
    const query = {};

    Object.entries({ ...state.retentionLeads.config.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
      }
    });

    return retention
      .downloadExport(query)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
        return false;
      });
  },
  async updateRetentionPagination({ commit, dispatch }, payload) {
    await commit("UPDATE_RETENTION_PAGINATION", payload);
    dispatch("loadRetentionLeads");
  },
  getRetentionAgents({commit}) {
    return retention.getAgents().then((res)=>{
      commit("setAgents",res.data);
    }).catch(()=>{
      commit("setRetentionReports",[]);
    });
  },
  getRetentionReports({commit},dates) {
    commit("setRetentionReports",[]);
    retention.getRetentionReports(dates.start,dates.end).then((res)=>{
      commit("setRetentionReports",res);
      return new Promise(resolve=>{ resolve(); });
    }).catch(()=>{
      commit("setRetentionReports",[]);
    });
  },

  async sendCustomerProformaInvoice({dispatch}, id) {
    try {
      await retention.sendCustomerProformaInvoice(id);
      dispatch('getAuditHistory', id);
      dispatch('alerts/setAlert', {type: 'success', message: 'Proforma invoice successfully sent'}, {root: true});
    } catch(err) {
      dispatch('alerts/setAlert', {type: 'error', message: 'Failed to send proforma invoice'}, {root: true});
    }
  },

  async fetchRetentionLeadNotes({ commit }, payload) {
    commit('FETCH_RETENTION_LEAD_NOTES_BEGIN');
    try {
      const data = await retention.fetchRetentionLeadNotes(payload);
      commit('FETCH_RETENTION_LEAD_NOTES_SUCCESS', data.data);
    } catch(err) {
      commit('FETCH_RETENTION_LEAD_NOTES_ERROR', err);
    }
  },

  async createRetentionLeadNote({ commit, dispatch }, {id, payload}) {
    commit('CREATE_RETENTION_LEAD_NOTE_BEGIN');
    try {
      await retention.createRetentionLeadNote(id, payload);
      commit('CREATE_RETENTION_LEAD_NOTE_SUCCESS');
      dispatch('retention/fetchRetentionLeadNotes', id, { root: true });
      dispatch('alerts/setAlert', {type: 'success', message: 'Note added successfully'}, { root: true });
    } catch(err) {
      commit('CREATE_RETENTION_LEAD_NOTE_ERROR', err);
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data.message}, { root: true });
    }
  }
};

const getters = {
  getSingleRetentionLead: state => state.singleRetentionLead,
  getRetentionLeadsLoading: state => state.retentionLeadsLoading,

  getAuditHistory: (state) => {
    let eventMap = {
      status: 'Status',
      customer_age_at_creation: 'Customer Age',
      proforma_fee: 'Proforma Fee',
      cancellation_fee: 'Cancellation Fee',
      notes: 'Notes',
      source: 'Source',
      department: 'Department',
      agent_sid: 'Agent',
      winning_provider: 'Winning Provider',
    };

    return state.auditHistory.logs.filter(item => item.event_detail !== 'notes').map(item => {      
      item.event_detail = (eventMap[item.event_detail]!==undefined)?eventMap[item.event_detail]:titleCase(item.event_detail.replace(/-/g,' ')); 
      return item;    
    });
  },
  
  getRetentionLeads: (state) => {
    return state.retentionLeads.leads.map((e) => {
      return {
        id: e.id,
        account_id: e.account_id,
        billing_account_business_name: e.billing_account_business_name,
        creation_timestamp: e.creation_timestamp,
        status: e.status,
        no_contact: e.no_contact,
        source: e.source,
        agent_sid: e.agent_sid,
        is_transfer: containsTransfer(e.cancellation_records),
        contains_voip: e.contains_voip,
        contains_telco: e.contains_telco,
        transfer_out_date: getLatestTransferDate(e.cancellation_records),
        closed_timestamp: e.closed_timestamp,
        last_changed: e.last_changed,
        contract_end_date: e.earliest_contract_end_date,
        saved_leads: {
          saved: savedLeads(e.cancellation_records),
          length: e.cancellation_records.length,
          display_format: `${savedLeads(e.cancellation_records)}/${
            e.cancellation_records.length
          }`,
        },
      };
    });
  },

  getRetentionConfigs: (state) => state.retentionLeads.config,

  getAgents: (state) => {
    return state.retentionLeads
      .filter((e) => !!e.agent_sid)
      .map((e) => {
        return e.agent_sid;
      });
  },

  getDropdowns: (state) => state.dropdowns,

  getRetentionLeadNotes: state => state.retentionLeadNotes,
  getFetchRetentionLeadNotesLoading: state => state.fetchRetentionLeadNotesLoading,
  getFetchRetentionLeadNotesError: state => state.fetchRetentionLeadNotesError,
  getFetchRetentionLeadNotesErrorResponse: state => state.fetchRetentionLeadNotesErrorResponse,

  getCreateRetentionLeadNoteLoading: state => state.createRetentionLeadNoteLoading,
  getCreateRetentionLeadNoteError: state => state.createRetentionLeadNoteError,
  getCreateRetentionLeadNoteErrorResponse: state => state.createRetentionLeadNoteErrorResponse,
};

const titleCase = (str) => {
  if(str===''){ return ''; }
  return str.toLowerCase().split(' ').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
};

const containsTransfer = (array) => {
  return array.some((e) => e.is_transfer) ? true : false;
};

const savedLeads = (array) => {
  return array.reduce((acc, { status }) => {
    return status === "Saved" ? acc + 1 : acc;
  }, 0);
};

const getLatestTransferDate = (array) => {
  if(array.length > 0) {
    return array
      .sort((a, b) => {
        if (a.cease_or_transfer_date !== null) {
          return;
        }
        return (
          new Date(a.cease_or_transfer_date).getTime() -
          new Date(b.cease_or_transfer_date).getTime()
        );
      })
      .reverse()[0].cease_or_transfer_date;
  }
  return;
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    adhocInvoice,
    proformaInvoice
  }
};
